const purchaseLinks = [
  {
    id: 1,
    platform: '네이버 스마트스토어',
    desc: '네이버 쇼핑 공식 스토어에서 전립상회 PAC KOREA 제품을 만나보세요. 네이버페이 포인트 적립 및 다양한 할인 혜택을 누리실 수 있습니다.',
    icon: 'ri-store-2-line',
    url: 'https://smartstore.naver.com/proactivecare',
    label: '스마트스토어 방문하기',
    highlight: true,
  },
];

const PurchaseSection = () => (
  <section id="purchase" className="py-24 md:py-32 bg-white">
    <div className="max-w-7xl mx-auto px-6 md:px-10">
      {/* Header */}
      <div className="text-center mb-16">
        <div className="flex items-center justify-center gap-3 mb-4">
          <div className="w-8 h-0.5 bg-[#1a2b4a]" />
          <span className="text-[#1a2b4a] text-xs font-semibold tracking-[0.25em] uppercase">Where to Buy</span>
          <div className="w-8 h-0.5 bg-[#1a2b4a]" />
        </div>
        <h2 className="text-3xl md:text-5xl font-bold text-[#1a2b4a] mb-4">구매 안내</h2>
        <p className="text-gray-400 text-base max-w-md mx-auto leading-relaxed">
          전립상회 PAC KOREA 제품은 아래 공식 판매 채널에서 구매하실 수 있습니다
        </p>
      </div>

      {/* Purchase Link */}
      <div className="flex justify-center">
        <a
          href={purchaseLinks[0].url}
          target="_blank"
          rel="noopener noreferrer nofollow"
          className="group flex flex-col sm:flex-row items-center gap-8 bg-[#03C75A] rounded-2xl px-12 py-10 w-full max-w-2xl transition-all duration-300 hover:-translate-y-1"
        >
          <div className="w-16 h-16 flex items-center justify-center rounded-xl bg-white/20 flex-shrink-0">
            <i className="ri-store-2-line text-3xl text-white" />
          </div>
          <div className="flex-1 text-center sm:text-left">
            <h3 className="text-xl font-bold text-white mb-2">{purchaseLinks[0].platform}</h3>
            <p className="text-white/80 text-sm leading-relaxed">{purchaseLinks[0].desc}</p>
          </div>
          <div className="inline-flex items-center gap-2 bg-white text-[#03C75A] text-sm font-bold px-6 py-3 rounded-full whitespace-nowrap group-hover:gap-3 transition-all duration-200 flex-shrink-0">
            {purchaseLinks[0].label}
            <i className="ri-arrow-right-line" />
          </div>
        </a>
      </div>

    </div>
  </section>
);

export default PurchaseSection;
